import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Highlight } from '../../search-data/sub-models/highlight.model';
import { LocationSuggestionResult } from './location-suggestion-result.model';

export const LOCATION_SUGGESTIONS_SCHEMA = Object.freeze({
  RESULTS: List<LocationSuggestionResult>(),
  HIGHLIGHTS: List<Highlight>(),
});
const RECORD = generateSchema(LOCATION_SUGGESTIONS_SCHEMA);
const KEYS: any = generateKeys(LOCATION_SUGGESTIONS_SCHEMA);

export class LocationSuggestions extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.RESULTS,
        value: props.get(KEYS.RESULTS)
          ? this.results.map((params) => new LocationSuggestionResult(params))
          : List<LocationSuggestionResult>([]),
      },
      {
        key: KEYS.HIGHLIGHTS,
        value: props.get(KEYS.HIGHLIGHTS)
          ? this.highlights.map((params) => new Highlight(params))
          : List<Highlight>([]),
      },
    ]);

    return selfModel as LocationSuggestions;
  }

  get results(): List<LocationSuggestionResult> {
    return this.get(KEYS.RESULTS);
  }

  get highlights(): List<Highlight> {
    return this.get(KEYS.HIGHLIGHTS);
  }
}
